import { render, staticRenderFns } from "./SidebarElem.vue?vue&type=template&id=2f720264&scoped=true"
import script from "./SidebarElem.vue?vue&type=script&lang=js"
export * from "./SidebarElem.vue?vue&type=script&lang=js"
import style0 from "./SidebarElem.vue?vue&type=style&index=0&id=2f720264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f720264",
  null
  
)

export default component.exports